import { ArticleResolution } from '@wix/answers-api';
import { useRouter } from 'next/router';
import React, { FunctionComponent, useContext } from 'react';

import { Context } from '../../../../context';
import { ArticleSearchResultItem } from '../../../../types';
import { isMobile } from '../../../../utils/user-agent';
import { RoadmapResolutionEta } from '../../../RoadmapResolutionEta';
import RoadmapVote from '../../RoadmapVote';

import css from './index.module.scss';

type RoadmapArticleListItemFooterProps = {
  article: ArticleSearchResultItem;
  followArticle: (articleId: string) => void;
  unFollowArticle: (articleId: string) => void;
  isFollowing: boolean;
  onClickStatus: (resolution: ArticleResolution) => void;
};
export const LABELS_LENGTH = 3;

export const MAX_PREVIEW_SIZE = 300;

export const RoadmapArticleListItemFooter: FunctionComponent<
  RoadmapArticleListItemFooterProps
> = ({
  article,
  followArticle,
  unFollowArticle,
  isFollowing,
  onClickStatus,
}: RoadmapArticleListItemFooterProps) => {
    const context = useContext(Context);
    const isMobileView = isMobile(context);
    const { locale } = useRouter();

    const clickFollowArticle = () => followArticle(article.id);
    const clickUnFollowArticle = () => unFollowArticle(article.id);

    const mobileFollowButton = (
      <RoadmapVote
        article={article}
        followArticle={clickFollowArticle}
        unFollowArticle={clickUnFollowArticle}
        locale={locale || 'en'}
        isFollowingArticle={isFollowing}
      />
    );

    return (
      <div className={`${css.tagsWrapper}`}>
        <RoadmapResolutionEta
          wrapEtaWithTag={false}
          resolution={article.resolution}
          resolutionEta={article.resolutionEta || undefined}
          onClickStatus={onClickStatus}
        />
        {article.resolution !== ArticleResolution.RELEASED &&
          isMobileView &&
          mobileFollowButton}
      </div>
    );
  };
